import { render, staticRenderFns } from "./PcActionChip.vue?vue&type=template&id=89565e16"
import script from "./PcActionChip.vue?vue&type=script&lang=js"
export * from "./PcActionChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VBadge,VChip})
